import React from 'react';

import { constants, locale } from '@trqk/utils';

const { MAX_AUDIO_UPLOAD_BATCH_SIZE } = constants;

interface MaxAudioBatchExceededInput {
    currentUploads: number;
}

/**
 * A toast message shown when a user tries to upload more than the max audio upload batch size at
 * once.
 */
export const MaxAudioBatchExceeded: ToastRenderContent<MaxAudioBatchExceededInput> =
    ({
        input,
    }: ToastRenderContentProps<MaxAudioBatchExceededInput>): JSX.Element => {
        const currentUploads = input?.currentUploads ?? 0;

        return (
            <div style={{ width: 300 }} className="px-2">
                <div className="font-bold text-highlight-orange tracking-wider mb-1">
                    {locale.enUS.UPLOAD_AUDIO.TOASTS.UPLOAD_ISSUE}
                </div>
                <div className="my-2">
                    {`${locale.enUS.UPLOAD_AUDIO.TOASTS.MAX_UPLOAD_BATCH_EXCEEDED.PART_1} ${MAX_AUDIO_UPLOAD_BATCH_SIZE} ${locale.enUS.UPLOAD_AUDIO.TOASTS.MAX_UPLOAD_BATCH_EXCEEDED.PART_2}`}
                </div>
                {currentUploads > 0 && (
                    <div className="my-2">
                        {`${locale.enUS.UPLOAD_AUDIO.TOASTS.MAX_UPLOAD_BATCH_EXCEEDED.PART_3}`}
                    </div>
                )}
            </div>
        );
    };
